import { render, staticRenderFns } from "./PlaceholderPost.vue?vue&type=template&id=67169c84&scoped=true&"
import script from "./PlaceholderPost.vue?vue&type=script&lang=js&"
export * from "./PlaceholderPost.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderPost.vue?vue&type=style&index=0&id=67169c84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67169c84",
  null
  
)

export default component.exports